import { Component, Input, OnDestroy } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MergeCustomerService } from '../../merge-customer.service';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';
import { Country } from '~core/models';

/**
 * Displays the last step of customer merge process.
 */
@UntilDestroy()
@Component({
  selector: 'app-review-data',
  templateUrl: 'review-data.component.html',
})
export class ReviewDataComponent implements OnDestroy {
  @Input() public selectedClub: any;
  @Input() public countries: Array<Country> = [];
  public combinedCustomerData: any = [];

  constructor(
    public tablesTranslations: TablesTranslations,
    private customerMergeService: MergeCustomerService
  ) {
    this.customerMergeService.castCombinedCustomer.pipe(untilDestroyed(this))
      .subscribe(data => this.combinedCustomerData = [data]);
  }

  public ngOnDestroy(): void { }

}
